import type {
    Currencies,
    NullEnum,
    BlankEnum,
} from "@/types/api/data-contracts";
import formatCurrency from "@/utils/currencyFormat";

const isZero = (price: string | number | null | undefined) =>
    price === 0 || price === "0";
/**
 * Formats a numeric value as a currency string with a specified currency code.
 *
 * @param {(string | number | null | undefined)} price - The numeric value to format as a currency string.
 * @param {(string | null | undefined | Currencies | BlankEnum | NullEnum)} currency - The currency code to use for formatting the value.
 * @returns {string} A string representing the formatted currency value or "--" if either price or currency is null or undefined.
 */
export function formatPriceWithCurrency(
    price: string | number | null | undefined,
    currency: string | null | undefined | Currencies | BlankEnum | NullEnum,
    allowZero = false,
    maxDecimals = 2
): string {
    if (!currency) return "--";

    if (allowZero && isZero(price))
        return formatCurrency(
            +(price as string | number),
            currency.toString(),
            maxDecimals
        );

    return price
        ? formatCurrency(+price, currency.toString(), maxDecimals)
        : "--";
}

export default formatPriceWithCurrency;
